import { reducer as formReducer } from 'redux-form';
import reducers from './reducers';
import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

export default combineReducers({
  router: routerReducer,
  form: formReducer,
  ...reducers,
});



// WEBPACK FOOTER //
// ./src/rootReducer.js